module.exports = __webpack_public_path__ + "img/profil.f417d032.svg";